var _rect, _circle, _path, _rect2, _path2, _circle2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 49,
    width: 16,
    height: 23,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 36,
    r: 5,
    fill: "#D4D5FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.407 16L7 33H13.5581L29.407 20.9355L46.8954 33H54L29.407 16Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 67,
    width: 18,
    height: 4,
    fill: "#D4D5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.087 17H32L53.4783 33L71 32.4483L50.087 17Z",
    fill: "#8D84F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 59.5,
    r: 1.5,
    fill: "#5B53B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9999 40V54H49.9999V40H63.9999ZM55.9999 52V48H51.9999V52H55.9999ZM57.9999 52H61.9999V48H57.9999V52ZM61.9999 46V42H57.9999V46H61.9999ZM51.9999 46V42H55.9999V46H51.9999Z",
    fill: "#231C70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 36C35 38.7614 32.7614 41 30 41C27.2386 41 25 38.7614 25 36C25 33.2386 27.2386 31 30 31C32.7614 31 35 33.2386 35 36ZM33 36C33 37.6569 31.6569 39 30 39C28.3431 39 27 37.6569 27 36C27 34.3431 28.3431 33 30 33C31.6569 33 33 34.3431 33 36Z",
    fill: "#231C70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 34L13 70H7C6.44772 70 6 70.4477 6 71C6 71.5523 6.44772 72 7 72L73 72C73.5523 72 74 71.5523 74 71C74 70.4477 73.5523 70 73 70H67.434V34H73C73.4316 34 73.8146 33.723 73.9497 33.3131C74.0849 32.9032 73.9417 32.4528 73.5947 32.1961L50.6136 15.1961C50.4414 15.0687 50.233 15 50.0189 15H29.5C29.4844 15 29.4688 15.0004 29.4534 15.0011C29.2249 14.9905 28.9939 15.0582 28.8026 15.2033L6.39564 32.2033C6.05354 32.4629 5.91534 32.9119 6.05226 33.3189C6.18918 33.7259 6.57065 34 7.00006 34H13ZM32.6123 17L54.312 32H69.9667L49.6892 17H32.6123ZM48 34V65H65.434V34H48ZM48 70V67H65.434V70H48ZM46 70L37 70V49H21V70H15V33.1592L29.4359 22.1703L46 33.5972V70ZM23 70V51H35V70H23ZM9.97259 32L29.4343 17.2345L50.7948 32H47.2069L29.9749 20.1123C29.6189 19.8668 29.1454 19.8779 28.8013 20.1398L13.2209 32H9.97259Z",
    fill: "#231C70"
  })));
}
export default SvgHouse;